import React from 'react';
import { Zap, Shield, Users } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function About() {
  const {
    t
  } = useLanguage();
  const stats = [{
    labelKey: 'satisfaction' as const,
    value: '100%'
  }, {
    labelKey: 'response' as const,
    value: '24h'
  }, {
    labelKey: 'support' as const,
    value: '7/24'
  }, {
    labelKey: 'revision' as const,
    value: '∞'
  }];
  const features = [{
    icon: Zap,
    key: 'fast' as const
  }, {
    icon: Shield,
    key: 'secure' as const
  }, {
    icon: Users,
    key: 'userCentric' as const
  }];
  return <section id="about" className="py-24 bg-slate-900" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-12">
          <div data-id="element-13">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-14">
              {t.about.title}
            </h2>
            <div className="space-y-6 text-lg text-slate-400" data-id="element-15">
              <p data-id="element-16">{t.about.description1}</p>
              <p data-id="element-17">{t.about.description2}</p>
              <p data-id="element-18">{t.about.description3}</p>
            </div>

            <div className="mt-12 grid grid-cols-2 gap-6" data-id="element-19">
              {stats.map(stat => <div key={stat.labelKey} className="p-4 rounded-xl bg-slate-800/50 border border-white/5" data-id="element-20">
                  <div className="text-3xl font-bold text-cyan-400 mb-1" data-id="element-21">
                    {stat.value}
                  </div>
                  <div className="text-sm text-slate-400" data-id="element-22">
                    {t.about.stats[stat.labelKey]}
                  </div>
                </div>)}
            </div>
          </div>

          <div className="space-y-8" data-id="element-23">
            {features.map(feature => <div key={feature.key} className="flex gap-4 p-6 rounded-2xl bg-slate-950 border border-white/5 hover:border-cyan-500/30 transition-colors" data-id="element-24">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-cyan-500/10 flex items-center justify-center text-cyan-400" data-id="element-25">
                  <feature.icon size={24} data-id="element-26" />
                </div>
                <div data-id="element-27">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-28">
                    {t.about.features[feature.key].title}
                  </h3>
                  <p className="text-slate-400" data-id="element-29">
                    {t.about.features[feature.key].description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}